import * as editor from '@wix/auto_sdk_urls_editor';
import * as site from '@wix/auto_sdk_urls_site';

export { editor, site };
